module.exports = __webpack_public_path__ + "img/5.184e7fdd.png";